import { Component, OnInit } from '@angular/core';
import { ReportingService } from 'src/app/services/reporting.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-student',
  templateUrl: './student.component.html',
  styleUrls: ['./student.component.scss']
})
export class StudentComponent implements OnInit {
  public userId;
  public practiceId;
  public reportData;
  public practiceProgrammes=[];
  public practiceProgrammeMemberData=[];
  public memberTotals=[];
  public loading:boolean=true;
  public start_date;
  public close_date;

  constructor(
    private _report: ReportingService,
    private  _route: ActivatedRoute
  ) {
    this._route.params.subscribe(params => {
      this.userId = +params['id'];
      this.practiceId = +params['pid'];
    });
  }

  public getUserReport(){
    this.reportData=null;
    this._report.getUserReport(this.practiceId, this.userId, this.start_date, this.close_date).subscribe(
      res=>{
        this.reportData=res[0].members;
        this.practiceProgrammes=res[1];
        this.practiceProgrammeMemberData=res[2];
        this.memberTotals=res[3];
        this.loading=false;
      }
    );
  }

  ngOnInit() {
    this.getUserReport();
  }

  formatStartDate(event){
    console.log(event);
    this.start_date=event.value.toISOString();
  }

  formatCloseDate(event){
    this.close_date=event.value.toISOString();
  }
}
